import { fetchFromServer, syncDependency, type DependencySyncConfig } from "./dependency-sync";
import { products } from "@/services/cache";
import { productsSyncKey } from "@/types/products/product-keys";
import type { ApiFetchResponse } from "@tmi/types/api/fetch";
import type { Products } from "@tmi/types/api/content-models";
import type { Product } from "@tmi/types/entities";

const config: DependencySyncConfig<Products, Product, Product> = {
    name: 'product',
    store: () => products,
    syncKey: productsSyncKey,
    throttle: { hours: 4 },
    queryId: 'b328c921a2e7a12d0894090087ef59b8',
    pageSize: 25,
    extractPayload: ( response: ApiFetchResponse<Products> ) => response?.data?.productCatalog?.products,
    mapItem: ( p: Product ): Product => p,
    postProcess: ( items: Product[] ) =>
        items.sort( ( a, b ) =>
            a.name.toLowerCase().localeCompare( b.name.toLowerCase() )
        )
};

export async function refreshProductsFromServer(): Promise<Product[]> {
    // Callers of this wrapper only want the records; partial-fetch handling lives in syncDependency.
    return ( await fetchFromServer( config ) ).items;
}

export async function loadProductMap( productsMap: Map<string, Product> ): Promise<boolean> {
    return syncDependency( config, productsMap );
}
